<script setup lang="ts">
import { useGetMe } from "@/auth/useMe";
import { useParticipateInCanvass } from "@/canvasses/canvassesCrud";
import type { CanvassParticipationState } from "@/canvasses/types";
import { ConflictError } from "@/gateways/apiClient";
import { useNotifications } from "@/notifications/useNotifications";
import { useRoute, useRouter } from "vue-router";

const { canvassId } = defineProps<{ canvassId: string }>();

const route = useRoute();
const router = useRouter();

const { addPendingNotification } = useNotifications();

const { participateInCanvass } = useParticipateInCanvass(canvassId, {
  onSuccess(result: CanvassParticipationState) {
    if (result === "pending") {
      addPendingNotification("Die Teilnahme wurde angefragt.");
    } else {
      addPendingNotification("Du nimmst jetzt an der Aktion teil.");
    }
  },
  onError(error) {
    if (error instanceof ConflictError) {
      addPendingNotification("Du nimmst bereits an der Aktion teil.");
    } else {
      addPendingNotification("Es ist etwas schiefgelaufen.");
    }
  },
  onSettled() {
    router.push({ name: "home" });
  },
});

useGetMe({
  onUnauthorizedError: () =>
    router.push({
      name: "signup",
      query: { redirectTarget: route.name?.toString(), canvassId },
    }),
  onSuccess: () => {
    participateInCanvass();
  },
});
</script>
<!-- this page is only for redirects -->
<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
